module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-studien-ec24c00c0f65a34a6a6c110638eff01b.svg";